import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * Move input data from dynamic form.
 *
 * @remarks
 * Despite its name, this is actually the output of a dynamic form presented
 * during move create in React. The structure is an indeterminate key-value
 * pairs object only one level deep (values are primitives, not nested objects).
 */
export const schema = z
  .record(z.string(), z.unknown())
  .describe(
    'Output data from the dynamic form presented during move create in React. Contains indeterminate key-value pairs (one level deep). Not user-configurable.'
  );

export type MoveInput = z.infer<typeof schema>;

export const definition = define({
  key: 'moveInput',
  schema,
  label: 'Move Input',
  description:
    'Output data from the dynamic form presented during move create in React. Contains indeterminate key-value pairs (one level deep). Not user-configurable.',
  kind: DEFINITION_KINDS.OUTPUT,
  category: CATEGORIES.OPERATIONAL_STATE.key,
  writableAtLevels: [LEVELS.MOVE],
  readableByRoles: [ROLES.ADMIN],
});
